import uuid from '../utils/uuid.utils';

export class ConsoleEvent {
  static log(eventData = '') {
    console.log(eventData);
    window.__CAAS__.triggerNative(
      window.__CAAS__.events.logConsole,
      uuid(),
      eventData,
    );
  }
}
